module.exports = require("core-js/modules/es.number.constructor.js");